import { render } from "./MyLeaveList.vue?vue&type=template&id=2d59fcda"
import script from "./MyLeaveList.vue?vue&type=script&lang=js"
export * from "./MyLeaveList.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/orangehrm/orangehrm/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__